import { render, staticRenderFns } from "./CreateEditMessage.vue?vue&type=template&id=7c3aa40b&scoped=true&"
import script from "./CreateEditMessage.vue?vue&type=script&lang=js&"
export * from "./CreateEditMessage.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditMessage.vue?vue&type=style&index=0&id=7c3aa40b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3aa40b",
  null
  
)

export default component.exports